import type { FC } from 'react';
import Tooltip from '@components/Tooltip';
import pluralize from 'pluralize';

interface EndorsementsCountBadgeProps {
  count: number | undefined;
  label?: string;
}

export const EndorsementsCountBadge: FC<EndorsementsCountBadgeProps> = ({ count, label }) => {
  if (count === undefined) {
    return null;
  }

  return (
    <Tooltip content={`${count} ${pluralize(label ?? '', count)}`} disabled={!label}>
      <div className="bg-info-100 inline-flex h-6 w-6 items-center justify-center rounded-full text-xs leading-4 text-gray-800">
        {count}
      </div>
    </Tooltip>
  );
};
